import OfficeBranchList from './office-branch-list';
import OfficeBranchDetail from './office-branch-detail';

export { OfficeBranchList, OfficeBranchDetail };
